import {alpha, styled} from '@mui/material/styles';
import {Card, Typography, Stack, Box} from '@mui/material';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({theme}) => ({
  boxShadow: 'none',
  textAlign: 'left',
  padding: theme.spacing(3),
  color: theme.palette.info.darker,
  backgroundColor: theme.palette.info.lighter,
  cursor: 'pointer'
}));

const ContributionItem = styled(Box)(({theme}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(0.5, 0),
  '&:not(:last-child)': {
    borderBottom: `1px solid ${alpha(theme.palette.info.dark, 0.1)}`
  }
}));

const SectionTitle = styled(Typography)(({theme}) => ({
  fontWeight: 'bold',
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(1),
  marginTop: theme.spacing(1)
}));

// ----------------------------------------------------------------------

export default function AppContributionValue({
                                               title,
                                               onClick,
                                               totalPinTuanCV,
                                               pinTuanCvPrice,
                                               pinTuanCvFundPool
                                             }) {
  return (
    <RootStyle onClick={onClick}>
      <Typography variant="subtitle1" sx={{fontWeight: 'bold', mb: 1}}>
        {title}
      </Typography>

      {/* 拼团贡献值 */}
      <Box>
        <SectionTitle variant="body2">拼团资金池</SectionTitle>
        <ContributionItem>
          <Typography variant="body2">资金：</Typography>
          <Typography variant="body2" sx={{fontWeight: 'bold'}}>{pinTuanCvFundPool || 0}</Typography>
        </ContributionItem>
        <ContributionItem>
          <Typography variant="body2">贡献值：</Typography>
          <Typography variant="body2" sx={{fontWeight: 'bold'}}>{Math.trunc(totalPinTuanCV || 0)}</Typography>
        </ContributionItem>
        <ContributionItem>
          <Typography variant="body2">单价：</Typography>
          <Typography variant="body2" sx={{fontWeight: 'bold'}}>{pinTuanCvPrice || 0}</Typography>
        </ContributionItem>
      </Box>
    </RootStyle>
  );
}
